export default __webpack_public_path__ + "static/media/up-down-icon.1129bb6d.svg";